export const seo = {
  seo: {
    jakooTitle: 'buy online » JAKO-O',
    jakooPrefixDescription: 'High-quality & selected',
    jakooSuffixDescription: '✓ Made for families. ✓ Tested by families. ➽ Order here at JAKO-O!',
    jakooProductDescription:
      '- at JAKO-O ✓ sustainable quality ✓ thoughtful function ✓ selected products: Order now!',
    habaTitle: 'buy online » HABA',
    habaPrefixDescription: 'High-quality & selected',
    habaSuffixDescription: '✓ Made for families. ✓ Tested by families: Order here at HABA!',
    habaProductDescription: '- at HABA ✓ sustainable quality ✓ thoughtful function ✓ : Order now!',
  },
};
